;(() => {
  if (window.__HH_FREE_SHIP__) return;
  window.__HH_FREE_SHIP__ = true;

  const moneyTextToCents = (text) => {
    if (!text) return null;
    const cleaned = String(text).replace(/[^0-9.]/g, '');
    if (!cleaned) return null;
    const value = parseFloat(cleaned);
    if (Number.isNaN(value)) return null;
    return Math.round(value * 100);
  };

  const update = () => {
    try {
      const drawer = document.getElementById('CartDrawer');
      if (!drawer) return;

      const bar = drawer.querySelector('.hh-free-ship');
      if (!bar) return;

      const goal = Math.round(parseFloat(bar.getAttribute('data-free-ship-goal') || '0') * 100);
      if (!goal) return;

      const subtotalEl = drawer.querySelector('[data-subtotal]');
      const subtotalCents = moneyTextToCents(subtotalEl ? subtotalEl.textContent : '');
      if (subtotalCents === null) return;

      const remaining = goal - subtotalCents;
      const pct = Math.max(0, Math.min(100, Math.floor((subtotalCents / goal) * 100)));

      const fill = bar.querySelector('[data-free-ship-fill]');
      const text = bar.querySelector('[data-free-ship-text]');
      const barOuter = bar.querySelector('.hh-free-ship__bar');

      if (fill) fill.style.width = pct + '%';
      if (barOuter) barOuter.setAttribute('aria-valuenow', String(pct));

      if (text) {
        text.innerHTML = remaining > 0
          ? `<strong>Add $${(remaining / 100).toFixed(2)}</strong> more for <strong>FREE shipping</strong>.`
          : `🎉 <strong>Free shipping unlocked!</strong>`;
      }
    } catch (e) {}
  };

  const boot = () => {
    update();

    const drawer = document.getElementById('CartDrawer');
    if (!drawer || !window.MutationObserver) return;

    let t;
    const obs = new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(update, 80);
    });
    obs.observe(drawer, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();